import {
    useEffect
}from "react"
import {
	useDebounce
}from "use-lodash-debounce"

const DebounceSearch = ({delay, minNumberOfSymbols, searchMethod, searchTerm}) => {
	const searchValue = useDebounce(searchTerm, delay)
    
    useEffect(() => {
		if (searchValue?.length >= minNumberOfSymbols)
			searchMethod(searchValue)
	}, [searchValue])

    return null
}
export default DebounceSearch
